<template>
  <div
    v-if="
      (account_type === 'school' && remarks.length) ||
      account_type === 'teacher'
    "
  >
    <div class="student-remark-section profile-block rounded-5">
      <div
        class="title-row d-flex justify-content-between align-items-center nowrap"
      >
        <!-- TITLE -->
        <div class="title-bold color_text text-uppercase">Remarks</div>
      </div>

      <!-- REMARK COMPONENT BLOCK -->
      <template v-if="remarks.length">
        <RemarkBlock
          v-for="remark in remarks"
          :key="remark.id"
          :teacher_image="remark.creator.image"
          :teacher_name="remark.creator.full_name"
          :remark_date="remark.created_at"
          teacher_subject="English Language"
          :teacher_remark="remark.remark"
        ></RemarkBlock>
      </template>
      <div class="col-12" v-else>
        <div
          class="d-flex justify-content-center align-items-center color_ash font-14"
        ></div>
      </div>
      <!-- REMARK COMPONENT BLOCK -->

      <!-- REMARK COMMENT -->
      <div
        v-if="account_type === 'teacher'"
        class="remark-comment-form-block d-flex justify-content-start align-items-start nowrap"
      >
        <!-- AVATAR -->
        <div class="avatar avatar-square avatar_md brand_inverse_light_bg">
          <img
            v-lazy="getAuthUser.image"
            :alt="getAuthUser.full_name"
            class="avatar-img"
            v-if="getAuthUser.image"
          />
          <div
            class="avatar-text brand_white font-18"
            :class="setAvatarBg"
            v-else
          >
            {{ getInitial(getAuthUser.full_name) }}
          </div>
        </div>

        <div class="comment-form w-100">
          <!-- FULLNAME -->
          <div class="name font-weight-bold color_ash">
            {{ getAuthUser.full_name }}
          </div>
          <!-- FORM INPUT -->
          <form action @submit.prevent="makeRemark(remark)" class="w-100">
            <textarea
              cols="30"
              rows="5"
              v-model="remark"
              class="form-control w-100"
              placeholder="Your comment here"
              style="resize: none"
            ></textarea>
            <div
              class="submit d-flex justify-content-end align-items-center no wrap"
            >
              <button
                ref="publish"
                type="submit"
                class="btn btn-md btn-accent"
                :disabled="remark.length == 0"
              >
                POST
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { setInitial } from "@/scripts/utilities";
import { setProfileBg } from "@/scripts/profile-colors";

export default {
  name: "RemarkSection",

  props: ["teacher_remarks", "id"],

  components: {
    RemarkBlock: () =>
      import(
        /* webpackChunkName: "RemarkBlock" */
        "@/components/profileComps/studentprofile/RemarkBlock"
      ),
  },

  computed: {
    ...mapGetters(["getAuthUser"]),

    setAvatarBg() {
      return setProfileBg(this.getAuthUser.full_name);
    },
  },

  data() {
    return {
      account_type: "",
      remark: "",
      remarks: this.teacher_remarks || [],
    };
  },

  created() {
    this.getAccountType();
  },

  mounted() {
    if (this.account_type === "parent" || this.account_type === "student")
      return;
    else this.fetchRemarks(this.id);
  },

  methods: {
    ...mapActions(["getRemarks", "postRemark"]),

    getAccountType() {
      this.account_type = this.$route.path.split("/")[1];
    },

    getInitial(name) {
      return setInitial(name);
    },

    fetchRemarks(id) {
      this.getRemarks({
        account: this.account_type,
        id,
      }).then((res) => {
        if (!res || !res.data || res.data.length == 0) return;
        this.remarks = res.data;
      });
    },

    makeRemark(remark) {
      this.$refs.publish.innerHTML =
        '<div class="icon-dotted-roller font-17 mr-2 animate"></div>Please wait...';

      this.postRemark({
        account: this.account_type,
        id: this.id,
        remark,
      }).then((res) => {
        if (res.code === 200) {
          this.remark = "";
          this.$refs.publish.innerHTML =
            '<div class="icon-accept font-17 mr-2"></div>Posted';
          return this.fetchRemarks(this.id);
        }
        this.$refs.publish.innerHTML =
          '<div class="icon-decline font-17 mr-2"></div>Failed';
      });
    },
  },
};
</script>

<style lang="scss">
.student-remark-section {
  .title-row {
    margin-bottom: 25px;
  }

  .remark-comment-form-block {
    margin-top: 20px;

    .avatar {
      margin-right: 20px;
    }

    .name {
      margin-bottom: 9px;
      font-size: 16px;
      line-height: 22px;

      @include breakpoint_max(sm) {
        font-size: 14px;
      }
    }

    .form-control {
      margin-bottom: 30px;
    }
  }
}
</style>
